import React, { ReactElement, useMemo } from 'react';
import { RadioGroup, FormControl, FormControlLabel, FormLabel, Radio } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { SCRadioButtonLabel, SCRadioButtonWrapper, SCRadioGroup, SCFormLabel, SCRadio } from './styles';
import { ITSRadioGroupProps } from './types';
import { TSRadioSizeEnum } from 'enums/TSRadioVariants';
import { TSTooltip } from 'components/atoms/TSTooltip';

const TSRadioGroup = ({
    id,
    radioGroupLabel,
    radioGroupValues,
    onChange,
    value,
    size,
    orientation,
    color
}: ITSRadioGroupProps): ReactElement => {
    const radioSize = useMemo(() => {
        if (size === TSRadioSizeEnum.MEDIUM) {
            return 28;
        } else if (size === TSRadioSizeEnum.LARGE) {
            return 32;
        }
        return 20;
    }, [size]);
    // console.info(
    //     '\n::::::::::::::::::::::::::::::::TSRadioGroup:::::::::::::::::::::::::::::::::',
    //     '\n::radioGroupValues::',
    //     radioGroupValues,
    //     '\n::onChange::',
    //     onChange,
    //     '\n::value::',
    //     value,
    //     '\n::size::',
    //     size,
    //     '\n::color::',
    //     color,
    //     '\n:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
    // );

    return (
        <>
            <SCRadioButtonWrapper>
                <SCFormLabel>
                    <FormLabel>{radioGroupLabel}</FormLabel>
                </SCFormLabel>
                <SCRadioGroup>
                    <RadioGroup onChange={onChange} value={value || null}>
                        <FormControl>
                            <SCRadio $orientation={orientation}>
                                {radioGroupValues?.map(function (element) {
                                    return (
                                        <SCRadioButtonLabel key={element.value} $color={color} $size={size}>
                                            <FormControlLabel
                                                name={radioGroupLabel}
                                                data-testid={`radio-label-${element.value}`}
                                                value={element.value}
                                                control={<Radio id={id} />}
                                                label={
                                                    element.tooltip ? (
                                                        <span
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '6px'
                                                            }}
                                                        >
                                                            {element.label}
                                                            <TSTooltip title={element.tooltip} arrow placement="right">
                                                                <InfoOutlinedIcon
                                                                    className="tooltip-icon"
                                                                    sx={{
                                                                        fontSize: 18,
                                                                        cursor: 'pointer',
                                                                        color: '#757575'
                                                                    }}
                                                                />
                                                            </TSTooltip>
                                                        </span>
                                                    ) : (
                                                        element.label
                                                    )
                                                }
                                                sx={{
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: radioSize
                                                    }
                                                }}
                                            />
                                        </SCRadioButtonLabel>
                                    );
                                })}
                            </SCRadio>
                        </FormControl>
                    </RadioGroup>
                </SCRadioGroup>
            </SCRadioButtonWrapper>
        </>
    );
};

export { TSRadioGroup };
